<template>
    <div class="portal-calendar">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.calendar || "Calendar" }}</h2>
            </div>
        </div>
        <div class="portal-toolbar">
            <v-list dense>
                <inertia-link :href="'/portal/calendar'">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName === 'portal.calendar.index'}">
                        <v-list-item-content>
                            <v-list-item-title>{{$page.props.lang.schedule || "Schedule"}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </inertia-link>
                <inertia-link :href="'/portal/calendar/appointments'">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName === 'portal.calendar.appointments'}">
                        <v-list-item-content>
                            <v-list-item-title>{{ $page.props.lang.myAppointments || "My Appointments"}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </inertia-link>
                <inertia-link :href="'/portal/calendar/appointments/past'">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName === 'portal.calendar.past'}">
                        <v-list-item-content>
                            <v-list-item-title>{{ $page.props.lang.pastAppointments || "Past Appointments"}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </inertia-link>
            </v-list>
            <v-btn v-if="!($vuetify.breakpoint.sm || $vuetify.breakpoint.xs) && $page.props.currentRouteName !== 'portal.calendar.past'" color="primary" 
            @click="showSessionModal = true">{{ $page.props.lang.book || "Book" }}</v-btn>
        </div>
        <div class="content">
            <slot></slot>
        </div>
        <v-fab-transition>
            <v-btn v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs" @click="showSessionModal = true"
            color="primary" fixed fab large dark bottom right class="mr-3 mb-3">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-fab-transition>
        <session-modal v-if="showSessionModal" :open="showSessionModal"></session-modal>
    </div>
</template>

<script>
import SessionModal from './../Components/BookSession'
import EventBus from '../../../../eventbus'

export default {
    data(){
        return{
           showSessionModal: false
        }
    },
     components: {
       SessionModal
    },
    created() {
        EventBus.$on('SHOW_SESSION_MODAL', (p) => {
            this.showSessionModal = true
        })

        EventBus.$on('CLOSE_SESSION_MODAL', (p) => {
            this.showSessionModal = false
        })
    },
    methods:{


    }

}
</script>
